<!-- 开题评审小组安排 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.2 34.64">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="26.04" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="26.04" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M21.11,13.39a4.09,4.09,0,1,0-6.06,0,7.16,7.16,0,0,0-4.13,6.48,1,1,0,1,0,2,0,5.13,5.13,0,0,1,10.26,0,1,1,0,1,0,2,0,7.15,7.15,0,0,0-4.13-6.48ZM16,10.66a2,2,0,1,1,2,2.05A2.05,2.05,0,0,1,16,10.66Z"
        />
        <path
          class="cls-3"
          d="M18.08,0A13.75,13.75,0,0,0,4.35,13.73v12.7a1,1,0,0,0,1,1H18.08A13.73,13.73,0,1,0,18.08,0Zm0,25.42H6.39V13.73A11.69,11.69,0,1,1,18.08,25.42Z"
        />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.2 34.64">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="26.04" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="26.04" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M21.11,13.39a4.09,4.09,0,1,0-6.06,0,7.16,7.16,0,0,0-4.13,6.48,1,1,0,1,0,2,0,5.13,5.13,0,0,1,10.26,0,1,1,0,1,0,2,0,7.15,7.15,0,0,0-4.13-6.48ZM16,10.66a2,2,0,1,1,2,2.05A2.05,2.05,0,0,1,16,10.66Z"
        />
        <path
          class="cls-3"
          d="M18.08,0A13.75,13.75,0,0,0,4.35,13.73v12.7a1,1,0,0,0,1,1H18.08A13.73,13.73,0,1,0,18.08,0Zm0,25.42H6.39V13.73A11.69,11.69,0,1,1,18.08,25.42Z"
        />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.2 36.4">
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.6" cy="27.8" rx="17.6" ry="8.6" />
        <ellipse class="cls-2" cx="17.6" cy="27.8" rx="13.61" ry="6.79" />
        <path
          class="cls-3"
          d="M21.17,13.39a4.08,4.08,0,1,0-6.06,0A7.16,7.16,0,0,0,11,19.87a1,1,0,1,0,2,0,5.13,5.13,0,1,1,10.26,0,1,1,0,1,0,2,0,7.16,7.16,0,0,0-4.14-6.48Zm-5.08-2.73a2.06,2.06,0,1,1,2.05,2.05A2.05,2.05,0,0,1,16.09,10.66Z"
        />
        <path
          class="cls-3"
          d="M18.14,0A13.74,13.74,0,0,0,4.42,13.73v12.7a1,1,0,0,0,1,1H18.14A13.73,13.73,0,1,0,18.14,0Zm0,25.42H6.45V13.73A11.69,11.69,0,1,1,18.14,25.42Z"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3 {
      fill: #9a9b9b;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3 {
      fill: #34aa91;
    }
  }
</style>
